import { lWindow } from 'usage-tracker-core/common/helpers';
import type { PartialHistory } from './types';

export const createHistory = (rWindow = lWindow): PartialHistory => {
  const hasWindowAndHistory =
    typeof rWindow === 'object' && typeof rWindow.history === 'object';

  const getCurrentState = () =>
    (hasWindowAndHistory &&
      rWindow.history.state &&
      rWindow.history.state.state) ||
    {};

  return {
    get location() {
      if (hasWindowAndHistory) {
        return {
          pathname: rWindow.location.pathname,
          search: rWindow.location.search,
          hash: rWindow.location.hash,
          state: getCurrentState(),
          key: getCurrentState().key || '',
        };
      }

      return {
        pathname: '',
        search: '',
        hash: '',
        state: getCurrentState(),
        key: getCurrentState().key || '',
      };
    },
    replace: (location, state: {} = {}) => {
      if (hasWindowAndHistory) {
        rWindow.history.replaceState(
          { ...state },
          '',
          typeof location === 'string'
            ? `${rWindow.location.origin}${location}`
            : location.toString()
        );
      }
    },
    push: (location, state: {} = {}) => {
      if (hasWindowAndHistory) {
        rWindow.history.pushState(
          { ...state },
          '',
          typeof location === 'string'
            ? `${rWindow.location.origin}${location}`
            : location.toString()
        );
      }
    },
  };
};
